"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const link_1 = __importDefault(require("next/link"));
const styled_components_1 = __importDefault(require("styled-components"));
const base_ui_components_atoms_button_1 = require("@motorata/base-ui.components.atoms.button");
const base_ui_components_atoms_icon_1 = __importDefault(require("@motorata/base-ui.components.atoms.icon"));
const base_ui_components_atoms__atoms_1 = require("@motorata/base-ui.components.atoms._atoms");
const base_ui_components_atoms_spinner_1 = __importDefault(require("@motorata/base-ui.components.atoms.spinner"));
const Link = (_a) => {
    var { children, href, query, hash, type = "primary", icon, disabled, padding = "12px 30px", hoverColor, hoverBackground, target, loading } = _a, rest = __rest(_a, ["children", "href", "query", "hash", "type", "icon", "disabled", "padding", "hoverColor", "hoverBackground", "target", "loading"]);
    return (react_1.default.createElement(StyledLink, Object.assign({ href: {
            pathname: href,
            query: query,
            hash: hash,
        }, target: target, styledType: type, disabled: disabled, padding: padding, hoverColor: hoverColor, hoverBackground: hoverBackground }, rest),
        react_1.default.createElement(base_ui_components_atoms__atoms_1.Row, { alignItems: "center", opacity: loading ? 0 : 1 },
            icon && react_1.default.createElement(base_ui_components_atoms_icon_1.default, { icon: icon }),
            children),
        loading && (react_1.default.createElement(base_ui_components_atoms__atoms_1.Absolute, { width: "100%", height: "100%", left: "0", top: "0", display: "flex", alignItems: "center", justifyContent: "center" },
            react_1.default.createElement(base_ui_components_atoms_spinner_1.default, { color: type === "primary" ? "white" : "primary", size: "20px" })))));
};
exports.default = Link;
const StyledLink = (0, styled_components_1.default)(link_1.default) `
  ${base_ui_components_atoms_button_1.buttonStyle};
`;
//# sourceMappingURL=Link.js.map